import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { UserProfileService } from '../services/user-profile.service';
import { ModuleAccessDto } from '@core/model/models';

export interface PermissionsData {
  modulePermissions: ModuleAccessDto | null;
  canList: boolean;
  canView: boolean;
  canCreate: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canImport: boolean;
}

export const permissionsResolver: ResolveFn<PermissionsData> = (route) => {
  const userProfileService = inject(UserProfileService);
  const moduleCode = route.data['moduleCode'] as string;

  if (!moduleCode) {
    console.warn('No moduleCode provided in route data');
    return createEmptyPermissions();
  }

  const modulePermissions = userProfileService.getModulePermissions(moduleCode);

  return {
    modulePermissions,
    canList: userProfileService.canList(moduleCode),
    canView: userProfileService.canView(moduleCode),
    canCreate: userProfileService.canCreate(moduleCode),
    canEdit: userProfileService.canEdit(moduleCode),
    canDelete: userProfileService.canDelete(moduleCode),
    canImport: userProfileService.canImport(moduleCode)
  };
};

function createEmptyPermissions(): PermissionsData {
  return {
    modulePermissions: null,
    canList: false,
    canView: false,
    canCreate: false,
    canEdit: false,
    canDelete: false,
    canImport: false
  };
}
